import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'
import { Prefix } from '@/types'

export interface ModalBibliographySearchResultContentStoreInterface {
  onBackCondition?: () => void
  onBackResult?: () => void
  onSelectContent?: (
    prefix: Prefix,
    bibliographyRealId: number,
    bibliographyContentId: number
  ) => void
}

type SelectContent = {
  prefix: Prefix
  bibliographyRealId: number
  bibliographyContentId: number
}

@Module({
  name: 'ModalBibliographySearchResultContentStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalBibliographySearchResultContentStore extends BaseStore {
  _isOpen: boolean = false

  _backConditionCallback?: () => void

  _backResultCallback?: () => void

  _selectContentCallback?: (
    prefix: Prefix,
    bibliographyRealId: number,
    bibliographyContentId: number
  ) => void

  get isOpen(): boolean {
    return this._isOpen
  }

  @Mutation
  public open(params?: ModalBibliographySearchResultContentStoreInterface) {
    this._isOpen = true
    if (params) {
      this._backConditionCallback = params.onBackCondition
      this._backResultCallback = params.onBackResult
      this._selectContentCallback = params.onSelectContent
    }
  }

  @Mutation
  public close() {
    this._isOpen = false
  }

  @Mutation
  public selectContent(selectContent: SelectContent) {
    if (this._selectContentCallback) {
      this._selectContentCallback(
        selectContent.prefix,
        selectContent.bibliographyRealId,
        selectContent.bibliographyContentId
      )
    }

    this._isOpen = false
  }

  @Mutation
  public back() {
    if (this._backConditionCallback) {
      this._backConditionCallback()
    }

    this._isOpen = false
  }

  @Mutation
  public backResult() {
    if (this._backResultCallback) {
      this._backResultCallback()
    }

    this._isOpen = false
  }
}
